import { gql } from '@apollo/client';

export const CREATE_ADS_WITH_CREATIVES_FAILED_AD_ENTITY_FIELDS = gql`
  fragment CreateAdsWithCreativesFailedAdEntityFields on CreateAdsWithCreativesFailedAdEntity {
    type
    name
    review
    status
    lineItemId
  }
`;
